export default __webpack_public_path__ + "static/media/client35.2113a699.png";